const ORDINAL_SUFFIXES = new Set(["st", "nd", "rd", "th"]);

const GO_DOMAIN = "https://go.fergmar.com";

/** Build the deterministic public short slug from a listing's street address. */
export function buildShortSlug(addressStreet1: string): string {
	return addressStreet1
		.trim()
		.split(/\s+/)
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join("");
}

/** Split a short slug into address tokens suitable for ILIKE matching against addressStreet1. */
export function tokenizeShortSlug(shortSlug: string): string[] {
	const rawTokens = shortSlug
		.trim()
		.split(/(?<=[a-z])(?=[A-Z])|(?<=[A-Za-z])(?=\d)|(?<=\d)(?=[A-Za-z])/u)
		.filter(Boolean);
	const tokens: string[] = [];

	for (let i = 0; i < rawTokens.length; i += 1) {
		const token = rawTokens[i];
		if (
			/^\d+$/.test(token) &&
			rawTokens[i + 1] &&
			ORDINAL_SUFFIXES.has(rawTokens[i + 1].toLowerCase())
		) {
			tokens.push(`${token}${rawTokens[i + 1]}`);
			i += 1;
		} else {
			tokens.push(token);
		}
	}

	return tokens;
}

/** Full short URL for a for-sale listing, ready to copy or print. */
export function buildShortUrl(addressStreet1: string): string {
	return `${GO_DOMAIN}/for-sale/${buildShortSlug(addressStreet1)}`;
}
